import { neutral, purpleBrand } from './primitives.colors';
import type { AridePaletteMode } from './buildPalette';
import { semanticDark } from './semantic.dark';
import { semanticLight } from './semantic.light';

export type ArideCustomColors = {
  brandMain: string;
  brandSupport: string;
  tertiaryMain: string;
  tertiaryContrastText: string;
  backgroundTertiary: string;
  backgroundMute: string;
  backgroundBlack: string;
  textPlaceholder: string;
  accent: string;
  elevation: string;
  charts: {
    chart1: string;
    chart2: string;
    chart3: string;
    chart4: string;
    chart5: string;
  };
  /** Compatível com QR / destaques que usavam `purple[400]` e `purple[750]`. */
  purple: {
    400: string;
    750: string;
  };
  /** Compatível com bordas que usavam `gray[700]`. */
  gray: {
    700: string;
  };
};

export function buildCustomColors(mode: AridePaletteMode): ArideCustomColors {
  const s = mode === 'dark' ? semanticDark : semanticLight;
  const purple750 = 'rgba(105, 25, 194, 0.4)';

  return {
    brandMain: s.brandMain,
    brandSupport: s.brandSupport,
    tertiaryMain: s.tertiaryMain,
    tertiaryContrastText: s.tertiaryContrastText,
    backgroundTertiary: s.backgroundTertiary,
    backgroundMute: s.backgroundMute,
    backgroundBlack: s.backgroundBlack,
    textPlaceholder: s.textPlaceholder,
    accent: s.accent,
    elevation: s.elevation,
    charts: {
      chart1: s.chart1,
      chart2: s.chart2,
      chart3: s.chart3,
      chart4: s.chart4,
      chart5: s.chart5
    },
    purple: {
      400: purpleBrand[400],
      750: purple750
    },
    gray: {
      700: neutral[800]
    }
  };
}
